module.exports = __webpack_public_path__ + "assets/img/09-l.c562a79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/09-l.jpg
// module id = G38D
// module chunks = 0